"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var classNames = require("classnames");
var Styles = require("spry-react/Popper/matrixPopperStyles");
var react_popper_1 = require("react-popper");
var transitionGroup_1 = require("spry-react/Animation/transitionGroup");
var animation_1 = require("spry-react/Animation/animation");
var delayedLoadingCover_1 = require("spry-react/LoadingCover/delayedLoadingCover");
var htmlUtils_1 = require("spry-react/utils/htmlUtils");
require("./matrixPopper.less");
var MatrixPopper = /** @class */ (function (_super) {
    __extends(MatrixPopper, _super);
    function MatrixPopper(props) {
        var _this = _super.call(this, props) || this;
        _this.willEnter = function () {
            return { opacity: 0 };
        };
        _this.didEnter = function () {
            if (_this.resolveTrigger() === 'click') {
                document.addEventListener("click", _this.onDocumentClick);
            }
            return { opacity: new animation_1.DurationAnimationDefinition(0, 1, 200) };
        };
        _this.willExit = function () {
            if (_this.resolveTrigger() === 'click') {
                document.removeEventListener("click", _this.onDocumentClick);
            }
            return { opacity: _this.state.closeImmediately ? 0 : new animation_1.DurationAnimationDefinition(1, 0, 200) };
        };
        _this.renderPopper = function (data, currentStyle) {
            var _a = _this.props, popperPlacement = _a.popperPlacement, noPaddingContent = _a.noPaddingContent;
            var renderedPopperContent;
            if (typeof _this.props.popperContent === "function") {
                renderedPopperContent = _this.state.promisePopperContent ||
                    React.createElement("div", { className: Styles.matrixPoppperLoading },
                        React.createElement(delayedLoadingCover_1.DelayedLoadingCover, { active: _this.state.isFetchingContent ? delayedLoadingCover_1.ActiveState.Active : delayedLoadingCover_1.ActiveState.Passive }));
            }
            else
                renderedPopperContent = _this.props.popperContent;
            return (React.createElement(react_popper_1.Popper, { key: 'popper', placement: popperPlacement || 'left', innerRef: function (node) { return _this.popperElement = node; }, modifiers: {
                    preventOverflow: {
                        enabled: false
                    },
                    //Don't think we really need this, but without it popper.js was throwing tons of warnings to the console
                    //about preventOverflow needing to be before hide. :shrug:
                    hide: {
                        enabled: false
                    }
                } }, function (_a) {
                var popperProps = _a.popperProps;
                var popperStyle = popperProps.style, popperPropsRest = __rest(popperProps, ["style"]);
                var mergedStyles = __assign(__assign({}, popperStyle), { opacity: currentStyle.opacity });
                var contentClasses = classNames(Styles.matrixPopperContent, {
                    'l-box': !noPaddingContent
                });
                var popper = (React.createElement("div", __assign({}, popperPropsRest, { className: Styles.matrixPopper, style: mergedStyles, onMouseOver: _this.onHovered, onMouseLeave: _this.onUnhovered }),
                    React.createElement("div", { className: contentClasses }, renderedPopperContent)));
                return ReactDOM.createPortal(popper, document.getElementById('popper-container'));
            }));
        };
        _this.targetClicked = function () {
            if (_this.resolveTrigger() !== 'click')
                return;
            _this.openPopper();
        };
        _this.onHovered = function () {
            if (_this.resolveTrigger() !== 'hover')
                return;
            _this.clearTimers();
            Pb.raiseEvent('popper.hovered', 'popper.hovered', _this);
            _this.showTimer = setTimeout(function () {
                _this.openPopper();
            }, 300);
        };
        _this.onUnhovered = function () {
            if (_this.resolveTrigger() !== 'hover')
                return;
            if (_this.showTimer)
                clearTimeout(_this.showTimer);
            _this.hideTimer = setTimeout(function () {
                _this.closePopper();
            }, 650);
        };
        _this.onDocumentClick = function (event) {
            if (_this.shouldClosePopper(event)) {
                _this.closePopper();
            }
        };
        _this.fetchPromiseContentIfNecessary = function () {
            if (_this.state.promisePopperContent === null && !_this.state.isFetchingContent && typeof _this.props.popperContent === "function") {
                _this.setState({
                    isFetchingContent: true
                });
                _this.props.popperContent(_this.closePopper).then(function (element) {
                    _this.setState({
                        isFetchingContent: false,
                        promisePopperContent: element
                    });
                });
            }
        };
        _this.clearTimers = function () {
            if (_this.showTimer)
                clearTimeout(_this.showTimer);
            if (_this.hideTimer)
                clearTimeout(_this.hideTimer);
        };
        _this.handleOtherPopperHovered = function (e, eventData) {
            if (eventData.data !== _this) {
                _this.clearTimers();
                if (_this.resolveIsOpen()) {
                    _this.closePopper(true);
                }
            }
        };
        _this.resolveTrigger = function () {
            if (!_this.props.trigger)
                return 'hover';
            if (_this.isExternalStateClickTrigger(_this.props.trigger))
                return 'click';
            else
                return _this.props.trigger;
        };
        _this.resolveIsOpen = function () {
            if (_this.isExternalStateClickTrigger(_this.props.trigger))
                return _this.props.trigger.isOpen;
            else
                return _this.state.isOpenInternalState;
        };
        _this.openPopper = function () {
            if (_this.isExternalStateClickTrigger(_this.props.trigger))
                _this.props.trigger.setExternalPopperState(true);
            _this.setState({
                isOpenInternalState: true,
                closeImmediately: false
            }, _this.fetchPromiseContentIfNecessary);
        };
        /*
         * This method is protected, allowing overriding, for a specific edge case -
         * when a flyout is opened on a popper. Because flyouts are rendered on a
         * portal, outside the popper's DOM tree, clicking a flyout would close a
         * popper. A custom popper implementation should test the click event against
         * the flyout's DOM tree, and not close.
         */
        _this.shouldClosePopper = function (event) {
            if (!_this.popperElement) {
                return false;
            }
            if (event.target && event.target instanceof HTMLElement) {
                return !htmlUtils_1.contains(event.target, _this.popperElement);
            }
            return false;
        };
        _this.closePopper = function (closeImmediately) {
            if (_this.isExternalStateClickTrigger(_this.props.trigger))
                _this.props.trigger.setExternalPopperState(false);
            _this.setState(function (prevState) { return ({
                isOpenInternalState: false,
                closeImmediately: closeImmediately == undefined ? prevState.closeImmediately : closeImmediately
            }); });
        };
        _this.state = {
            isOpenInternalState: false,
            isFetchingContent: false,
            promisePopperContent: null,
            closeImmediately: false
        };
        return _this;
    }
    MatrixPopper.prototype.render = function () {
        return (React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Target, null,
                React.createElement("div", { onClick: this.targetClicked, onMouseOver: this.onHovered, onMouseLeave: this.onUnhovered }, this.props.target)),
            React.createElement(transitionGroup_1.TransitionGroup, { data: this.resolveIsOpen() ? [{ key: 'foo' }] : [], willEnter: this.willEnter, didEnter: this.didEnter, willExit: this.willExit, renderChild: this.renderPopper })));
    };
    MatrixPopper.prototype.componentDidMount = function () {
        Pb.on('popper.hovered', this.handleOtherPopperHovered);
    };
    MatrixPopper.prototype.componentWillUnmount = function () {
        this.clearTimers();
        Pb.off('popper.hovered', this.handleOtherPopperHovered);
    };
    MatrixPopper.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.popperContent != this.props.popperContent) {
            this.setState({ promisePopperContent: null }, function () {
                if (_this.resolveIsOpen())
                    _this.fetchPromiseContentIfNecessary();
            });
            return;
        }
        if (this.isExternalStateClickTrigger(this.props.trigger) && this.props.trigger.isOpen)
            this.fetchPromiseContentIfNecessary();
    };
    MatrixPopper.prototype.isExternalStateClickTrigger = function (trigger) {
        return trigger != undefined && trigger.isOpen !== undefined;
    };
    return MatrixPopper;
}(React.Component));
exports.MatrixPopper = MatrixPopper;
